import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import * as checklistActions from 'store/resource/checklist/actions';
import {
  getCountListItem,
  getCountCheckedListItem,
  getChecklistProgress
} from 'store/resource/checklist/selectors';
import { getContents } from 'store/contents/selectors';
import ProgressBar from 'components/common/ProgressBar';
import { RootAppState } from 'store/types';
import { localize } from 'core/localization';
import { isIE } from 'utils/window';

import ContentList from 'components/contents/ContentList/ContentList';

import {
  ChecklistWrapper,
  ChecklistProgressWrapper,
  ProgressBarSubscription,
  ProgressBarContainer,
  ChecklistProgressAdaptWrapper,
  ProgressBarArea
} from './Checklist.styled';

type ChecklistProps = {
  content: string;
  inverted: boolean;
  childrenElements: any[];
  linkTabIndex?: number;
};

type ChecklistState = {
  isProgressBarFixed: boolean;
  scrollWidth: number;
};

const scrollToProgressBar = isIE() ? 76 : 0;

class Checklist extends React.PureComponent<
  ChecklistProps & ConnectedProps<typeof connector>,
  ChecklistState
> {
  progressBarRef: any;

  checklistRef: any;

  resourceScrollContainer: HTMLElement | null;

  constructor(props: ChecklistProps & ConnectedProps<typeof connector>) {
    super(props);
    this.progressBarRef = React.createRef();
    this.checklistRef = React.createRef();
    this.resourceScrollContainer = null;
    this.state = {
      isProgressBarFixed: false,
      scrollWidth: 0
    };
  }

  async componentDidMount() {
    this.resourceScrollContainer = document.querySelector('.resource-scroll-container');
    const scrollWidth =
      window.innerWidth - (this.resourceScrollContainer?.clientWidth || window.innerWidth);
    this.setState({ scrollWidth });
    await this.props.actions.initChecklist(this.props.childrenElements);

    window.addEventListener('scrollPage', this.onScrollHandler);
  }

  onScrollHandler = () => {
    if (
      this.checklistRef.current &&
      this.checklistRef.current.getBoundingClientRect().top <= scrollToProgressBar
    ) {
      !this.state.isProgressBarFixed && this.setProgressBarFixed(true);
    } else {
      this.state.isProgressBarFixed && this.setProgressBarFixed(false);
    }
  };

  setProgressBarFixed = (isFixed: boolean) => {
    this.setState({
      isProgressBarFixed: isFixed
    });

    if (isIE()) {
      this.resourceScrollContainer?.classList.toggle('resource-layout-offset', isFixed);
    }
  };

  render() {
    const {
      childrenContents,
      checkListProgress,
      countCheckedListItem,
      countListItem,
      inverted,
      linkTabIndex
    } = this.props;

    return (
      <ChecklistWrapper className="ChecklistWrapper" ref={this.checklistRef}>
        <ProgressBarArea>
          <ChecklistProgressAdaptWrapper
            className={`${this.state.isProgressBarFixed && 'sticky'}`}
            scrollWidth={this.state.scrollWidth}
          >
            <ChecklistProgressWrapper ref={this.progressBarRef}>
              <ProgressBarContainer>
                <ProgressBar
                  progressColor={'mainColor'}
                  progress={checkListProgress}
                  height={4}
                  className={'checklist-progress'}
                />
              </ProgressBarContainer>
              <ProgressBarSubscription checkListProgress={checkListProgress}>
                {countCheckedListItem}/{countListItem} {localize('[completed]')}
              </ProgressBarSubscription>
            </ChecklistProgressWrapper>
          </ChecklistProgressAdaptWrapper>
        </ProgressBarArea>
        {childrenContents.length > 0 && (
          <ContentList
            items={childrenContents}
            isLoading={false}
            inverted={inverted}
            linkTabIndex={linkTabIndex}
          />
        )}
      </ChecklistWrapper>
    );
  }
}

function mapStateToProps(state: RootAppState, ownProps: ChecklistProps) {
  return {
    countListItem: getCountListItem(state),
    countCheckedListItem: getCountCheckedListItem(state),
    checkListProgress: getChecklistProgress(state),
    childrenContents: getContents(state, ownProps.childrenElements)
  };
}

function mapDispatchToProps(dispatch: Dispatch): { [key: string]: any } {
  return {
    actions: bindActionCreators(checklistActions, dispatch)
  };
}
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(Checklist);
